import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';

import {
  PrioridadMantenimiento,
  PrioridadMantenimientoCreate
} from '../model/prioridad-mantenimiento.model';

interface PrioridadesResponse {
  codigo: number;
  mensaje: string;
  data: PrioridadMantenimiento[];
}

interface PrioridadResponse {
  codigo: number;
  mensaje: string;
  data: PrioridadMantenimiento;
}

@Injectable({
  providedIn: 'root'
})
export class PrioridadMantenimientoService {

  private apiUrl =
    `${environment.apiUrl}/api/prioridades-mantenimiento`;

  constructor(
    private http: HttpClient
  ) {}

  /**
   * Obtener prioridades activas
   */
  getAll(): Observable<PrioridadMantenimiento[]> {

    return this.http
      .get<PrioridadesResponse>(
        this.apiUrl,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Obtener prioridad por ID
   */
  getById(
    id: number
  ): Observable<PrioridadMantenimiento> {

    return this.http
      .get<PrioridadResponse>(
        `${this.apiUrl}/${id}`,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Crear prioridad
   */
  create(
    data: PrioridadMantenimientoCreate
  ): Observable<PrioridadMantenimiento> {

    return this.http
      .post<PrioridadResponse>(
        this.apiUrl,
        data,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Actualizar prioridad
   */
  update(
    id: number,
    data: Partial<PrioridadMantenimientoCreate>
  ): Observable<PrioridadMantenimiento> {

    return this.http
      .put<PrioridadResponse>(
        `${this.apiUrl}/${id}`,
        data,
        {
          withCredentials: true
        }
      )
      .pipe(
        map(response => response.data)
      );
  }

  /**
   * Desactivar prioridad
   */
  delete(
    id: number
  ): Observable<void> {

    return this.http
      .delete<void>(
        `${this.apiUrl}/${id}`,
        {
          withCredentials: true
        }
      );
  }
}